import { render, staticRenderFns } from "./le-role-de-lintelligence-artificielle-dans-le-marketing-digital.vue?vue&type=template&id=2f4c9c64&"
import script from "./le-role-de-lintelligence-artificielle-dans-le-marketing-digital.vue?vue&type=script&lang=js&"
export * from "./le-role-de-lintelligence-artificielle-dans-le-marketing-digital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports